exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/* \nAdding transition animations for list items\n*/\n.list-enter-active[data-v-7a9e9a34] {\n  animation: fade-in-7a9e9a34 0.5s ease-in-out;\n}\n.list-leave-active[data-v-7a9e9a34] {\n  animation: fade-in-7a9e9a34 0.5s ease-in-out reverse;\n}\n@keyframes fade-in-7a9e9a34 {\n0% {\n    opacity: 0;\n    transform: translateY(30px);\n}\n100% {\n    transform: translateY(0px);\n}\n}\n", ""]);

// exports
